import { ref, watchEffect } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import CaptainInboxesAPI from 'dashboard/api/saas/captainInboxes';

// Module-level cache: the inbox -> assistant map is fetched once per account
// per page load and shared by every consumer of this composable.
const assistantsByInboxId = ref({});
const fetchedAccountIds = new Set();

export function useCaptainInboxMap() {
  const accountId = useMapGetter('getCurrentAccountId');
  const isFeatureEnabledonAccount = useMapGetter(
    'accounts/isFeatureEnabledonAccount'
  );

  watchEffect(async () => {
    try {
      const id = accountId.value;
      if (!id || fetchedAccountIds.has(id)) return;
      if (!isFeatureEnabledonAccount.value(id, FEATURE_FLAGS.CAPTAIN)) return;

      fetchedAccountIds.add(id);
      const { data } = await CaptainInboxesAPI.get();
      const map = {};
      (data.payload || []).forEach(item => {
        map[item.inbox_id] = {
          id: item.assistant_id,
          name: item.assistant_name,
        };
      });
      assistantsByInboxId.value = { ...assistantsByInboxId.value, ...map };
    } catch (error) {
      // No Vuex store in this context (component specs/stories), Captain not
      // available (403), or a transient failure — consumers silently fall
      // back to no badges/default labels.
    }
  });

  const assistantForInbox = inboxId =>
    inboxId ? assistantsByInboxId.value[Number(inboxId)] : undefined;

  return { assistantForInbox };
}
